/**
 * TODO: REFACTOR - Move this component higher up the folder structure
 * Also used by Multi-Depth Soil Moisture Graph to select the date range for the graph
 */

import { Stack, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers";

import { DateRangeButtons } from "./date-range-buttons";

interface DateRangeSelectorProps {
    startDate: Date;
    setStartDate: (newStartDate: Date) => void;
    endDate: Date;
    setEndDate: (newEndDate: Date) => void;
    presetDateButtonOptions:
        | { label: string; presetKey?: string; getDates(): { startDate: Date; endDate: Date } }[]
        | undefined;
    showDescriptionText: boolean;
    useStartOfDayEndOfDay?: boolean;
}

export function DateRangeSelector({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    presetDateButtonOptions,
    showDescriptionText = false,
    useStartOfDayEndOfDay = false,
}: DateRangeSelectorProps) {
    const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return (
        <div className={"flex flex-col gap-6"}>
            {showDescriptionText && (
                <>
                    <Typography variant={"h4"}>Date Range</Typography>
                    <Typography variant={"subtitle1"}>
                        Dates are <strong>inclusive</strong> and in your local timezone.
                    </Typography>
                    <Typography variant={"subtitle1"}>
                        Local timezone: <i>{`${timeZone}`}</i>
                    </Typography>
                </>
            )}

            <div className={"flex flex-col gap-6"}>
                <DateRangeButtons
                    onClick={(newStartDate, newEndDate) => {
                        setStartDate(newStartDate);
                        setEndDate(newEndDate);
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    presetDateButtonOptions={presetDateButtonOptions}
                />

                <Stack direction={"row"} spacing={4}>
                    <DatePicker
                        label={"Start Date"}
                        renderInput={(params) => <TextField size={"small"} {...params} />}
                        value={startDate}
                        onChange={(newStartDate: Date | null) => {
                            if (useStartOfDayEndOfDay) {
                                newStartDate?.setHours(0, 0, 0, 0);
                            }
                            if (newStartDate) {
                                setStartDate(newStartDate);
                            }
                        }}
                        maxDate={endDate}
                    />
                    <DatePicker
                        label={"End Date"}
                        renderInput={(params) => <TextField size={"small"} {...params} />}
                        value={endDate}
                        onChange={(newEndDate: Date | null) => {
                            if (useStartOfDayEndOfDay) {
                                newEndDate?.setHours(23, 59, 59, 999);
                            }
                            if (newEndDate) {
                                setEndDate(newEndDate);
                            }
                        }}
                        minDate={startDate}
                    />
                </Stack>
            </div>
        </div>
    );
}
